export default __webpack_public_path__ + "media/images/evangelion/evangelion2-74ea047af1b93c3380d85e86d3f559cd.png";